import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectionType, TableColumn } from '@swimlane/ngx-datatable';
import { Observable } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';

import { Submarca } from '../../modelos/Promocion';
import { PromocionesService } from '../../services/promociones.service';

@Component({
  selector: 'app-promo-submarca-list',
  templateUrl: './promo-submarca-list.component.html',
  styleUrls: ['./promo-submarca-list.component.css']
})
export class PromoSubmarcaListComponent implements OnInit {

  formFindSubmarca: FormGroup;
  columns: TableColumn[] = [];
  itemsCounts: number[] = [10, 25, 50];
  pageSize = this.itemsCounts[0];
  selectionType = SelectionType;

  filteredRows$: Observable<Submarca[]>;
  dataSource$: Observable<Submarca[]>;

  selected: Submarca[] = [];

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<Submarca[]>();

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly promocionesService: PromocionesService,
  ) {
    this.gridColumns();
    this.buidForm();
  }

  ngOnInit(): void {
    this.dataSource$ = this.promocionesService.getSubmarcas().pipe(
      tap((res) => {
        if (res.length < 0) return;
        this.filteredRows$ = this.formFindSubmarca.valueChanges.pipe(
          startWith(''),
          map(({ filter, option }) => filter ? this._filter(filter, res, option) : res)
        )
      })
    );
  }

  gridColumns() {
    this.columns = [
      {
        width: 30,
        sortable: false,
        draggable: false,
        canAutoResize: false,
        resizeable: false,
        headerCheckboxable: true,
        checkboxable: true
      },
      {
        name: 'ID Submarca',
        prop: 'idSubMarca',
        width: 50,
        sortable: false,
        draggable: false,
        headerClass: 'fw-bold'
      },
      {
        name: 'Submarca',
        prop: 'descripcionSubMarca',
        width: 100,
        sortable: false,
        draggable: false,
        headerClass: 'fw-bold'
      }
    ];
  }

  buidForm() {
    this.formFindSubmarca = this._formBuilder.group({
      filter: [''],
      option: [this.columns[0].prop]
    });
  }

  private _filter(value: string, arr: Submarca[], scope: string) {
    return arr.filter((option) => `${option[scope]}`.toLowerCase().includes(`${value.toLowerCase()}`))
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

}
